import styled from "styled-components";

const Style = {
	Wrapper: styled.div`
		display: flex;
		flex-direction: column;
		align-items: center;
		gap: 24px;
		padding: 32px;
		background-color: ${({theme}) => theme.color.white};
		border-radius: 16px;
	
		@media (max-width: ${({theme}) => theme.breakpoints.mobile}) {
			padding: 40px 12px;
		}
	`,
	Input: styled.input`
		display: none;
	`,
}

export default Style
